// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scrolling .v-tabs-items.full-height-tab .v-window-item[data-v-125ea0c1]{height:calc(100vh - 78px);width:100%;overflow-y:auto;overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
